import Link from "next/link";

import { ForgeLogoWord } from "~/assets";
import { cn } from "~/services/shadcn";

export const NavbarLogo = ({ className }: { className?: string }) => {
  return (
    <Link href="/" className={cn("flex shrink-0 flex-col items-center justify-center", className)}>
      <ForgeLogoWord className="w-[80px] md:w-[100px]" width={120} height={36} />
    </Link>
  );
};
